import './bootstrap';
import './jquery-ui.min.js'
import 'persian-datepicker/dist/js/persian-datepicker.min'

// Global Vars and Functions
let body_class = '';
let first_visit = true;
let scroll_top_sidebar = 0;
let output_page = false;
let timer_interval = null;

function get_livewire_id(el) {
    let jel;
    if (el instanceof jQuery) {
        jel = el.parents();
    } else {
        jel = $(el).parents();
    }

    if (jel.length) {
        for (let i = 0; i < jel.length; i++) {
            var attr = $(jel[i]).attr('wire:id');
            if (typeof attr !== 'undefined' && attr !== false) {
                return attr;
            }
        }
    }

    return false;
}

function get_livewire_vars(el, name) {
    if (name.toString().trim() === '') {
        return false;
    }

    let jel;
    if (el instanceof jQuery) {
        jel = el.parents();
    } else {
        jel = $(el).parents();
    }

    if (jel.length) {
        for (let i = 0; i < jel.length; i++) {
            var attr = $(jel[i]).attr('wire:id');
            if (typeof attr !== 'undefined' && attr !== false) {
                return Livewire.find(attr).get(name);
            }
        }
    }

    return '';
}

function set_livewire_vars(el, name, value, live = false) {
    if (name.toString().trim() === '') {
        return false;
    }

    let jel;
    if (el instanceof jQuery) {
        jel = el.parents();
    } else {
        jel = $(el).parents();
    }

    if (jel.length) {
        for (let i = 0; i < jel.length; i++) {
            var attr = $(jel[i]).attr('wire:id');
            if (typeof attr !== 'undefined' && attr !== false) {
                Livewire.find(attr).set(name, value, live);
                return true;
            }
        }
    }

    return false;
}

function zeroPad(num) {
    return num.toString().padStart(2, "0");
}

function disableScroll(element) {
    // Get the current page scroll position
    if (element) {
        let scrollTop = element.scrollTop;
        let scrollLeft = element.scrollLeft;

        // if any scroll is attempted, set this to the previous value
        element.onscroll = function () {
            element.scrollTo(scrollLeft, scrollTop);
        };
    } else {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

        // if any scroll is attempted, set this to the previous value
        window.onscroll = function () {
            window.scrollTo(scrollLeft, scrollTop);
        };
    }
}

function enableScroll(element) {
    if (element) {
        element.onscroll = function () {
        };
    } else {
        window.onscroll = function () {
        };
    }
}

function removeAllInstances(arr, item) {
    for (var i = arr.length; i--;) {
        if (arr[i] == item) arr.splice(i, 1);
    }
}

function fa2en(str) {
    let persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
    let arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];

    if (typeof str === 'string') {
        for (var i = 0; i < 10; i++) {
            str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
        }
    }

    return str;
}

function en2fa(str) {
    let persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    let arabicNumbers = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];

    if (typeof str === 'string') {
        for (var i = 0; i < 10; i++) {
            str = str.replaceAll(i, persianNumbers[i]).replaceAll(arabicNumbers[i], persianNumbers[i]);
        }
    }

    return str;
}

function formatMoney(number) {
    number = fa2en(number);
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function loading_section() {
    if ($('.home-section').length) {
        $('.home-section').addClass('active-loading');
    }
}
window.loading_section = loading_section;

function transform_money_input() {
    $('.number:not(.init_money)').each(function () {
        $(this).addClass('init_money');
        $(this).on('input', function () {
            let clear_money = fa2en($(this).val().toString().replaceAll(',', ''));
            clear_money = clear_money.replace(/[^0-9.-]/g, '').replace(/(\..*?)\..*/g, '$1');
            if (clear_money[0] == '-' && $(this).attr('data-negative') == 'true') {
                clear_money = clear_money.replaceAll('-', '');
                clear_money = '-' + clear_money;
            } else {
                clear_money = clear_money.replaceAll('-', '');
            }

            let max_num = parseFloat($(this).attr('data-max'));
            if (max_num && clear_money > max_num) {
                clear_money = max_num.toString();
            }

            let formatted_money;
            let float = parseInt($(this).attr('data-float'));
            if (float > 0 && clear_money.indexOf('.') > -1) {
                let index = clear_money.indexOf('.');
                let add_str = clear_money.substring(index).replaceAll('.', '');
                let main_str = clear_money.substring(0, index);
                if (main_str.length === 0) {
                    if (add_str.length) {
                        formatted_money = '0.' + add_str.toString().substring(0, float);
                    } else {
                        formatted_money = '.';
                    }
                } else {
                    if ($(this).attr('data-separator') == 'true') {
                        formatted_money = formatMoney(main_str) + '.' + add_str.substring(0, float);
                    } else {
                        formatted_money = main_str + '.' + add_str.substring(0, float);
                    }
                }
            } else {
                let index = clear_money.indexOf('.');
                if (index > -1) {
                    let point_text = clear_money.substring(index);
                    clear_money = clear_money.replace(point_text, '');
                }

                if ($(this).attr('data-separator') == 'true') {
                    formatted_money = formatMoney(clear_money);
                } else {
                    formatted_money = clear_money;
                }
            }

            $(this).val(formatted_money);
            set_livewire_vars(this, $(this).attr('wire:model'), formatted_money);
        });
        $(this).trigger('input');
    });
}

function handle_file_input() {
    $('.file_livewire_input:not(.init_upload)').each(function () {
        let dropArea = this;
        $(dropArea).addClass('init_upload');
        dropArea.addEventListener('dragenter', preventDefaults, false);
        dropArea.addEventListener('dragover', preventDefaults, false);
        dropArea.addEventListener('dragleave', handleDragLeave, false);
        dropArea.addEventListener('drop', handleDrop, false);

        dropArea.addEventListener('dragenter', highlight, false);
        dropArea.addEventListener('dragover', highlight, false);
        //dropArea.addEventListener('dragleave', unhighlight, false);
        //dropArea.addEventListener('drop', unhighlight, false);

        function preventDefaults(event) {
            event.preventDefault();
            event.stopPropagation();
        }

        function highlight() {
            dropArea.classList.add('highlight');
            $(dropArea).find('.first-div-upload .drop-text').html('فایل را رها کنید')
        }

        function unhighlight() {
            setTimeout(function () {
                dropArea.classList.remove('highlight');
                $(dropArea).find('.first-div-upload .drop-text').html('فایل را بکشید و اینجا رها کنید یا کلیک کنید')
            }, 10);
        }

        function handleDragLeave(event) {
            if ($(event.relatedTarget).hasClass('file_livewire_input') || $(event.relatedTarget).parents('.file_livewire_input').length > 0) {
                return;
            }
            /*
            if (event.relatedTarget !== null) {
                return;
            }*/
            unhighlight();
        }

        function handleDrop(event) {
            event.preventDefault();
            if (!$(dropArea).hasClass('highlight')) return;
            dropArea.classList.remove('highlight');
            let id = $(dropArea).parent().attr('for');
            let input_file = $('#' + id)[0];
            if (event.dataTransfer.files.length) {
                for (let i = 0; i < event.dataTransfer.files.length; i++) {
                    if (event.dataTransfer.files[0].type === '') {
                        Livewire.dispatch('load_alert', {
                            type: 'error',
                            'text': 'شما نمیتوانید یک پوشه را آپلود کنید',
                            'closeModal': false
                        });
                        return;
                    }
                }
                input_file.files = event.dataTransfer.files;
                input_file.dispatchEvent(new Event('change'))
            }
            unhighlight();
        }
    });
}

function handle_select2() {
    $.fn.select2.amd.define('select2/selectAllAdapter', [
        'select2/utils',
        'select2/dropdown',
        'select2/dropdown/attachBody'
    ], function (Utils, Dropdown, AttachBody) {

        function SelectAll() {
        }

        SelectAll.prototype.render = function (decorated) {
            var self = this,
                $rendered = decorated.call(this),
                $selectAll = $(
                    '<button class="select2-results__option select2-results__option--selectable select-all-select2" type="button" style="width: 100%;border: none;text-align: right;"><i class="fa fa-check-square-o"></i> انتخاب همه</button>'
                ),
                $btnContainer = $('<div>').append($selectAll),
                $element = this.$element;

            if (!$element.prop("multiple")) {
                return $rendered;
            }

            $rendered.find('.select2-dropdown').prepend($btnContainer);

            $selectAll.on('click', function (e) {
                var $results = $rendered.find('.select2-results__option');

                $results.each(function () {
                    var data = Utils.GetData(this, 'data');
                    if (!data) {
                        return;
                    }

                    self.trigger('select', {
                        data: data
                    });
                });

                self.trigger('close');
            });

            return $rendered;
        };

        return Utils.Decorate(
            Utils.Decorate(
                Dropdown,
                AttachBody
            ),
            SelectAll
        );
    });

    $('select.select2').each(function () {
        if ($(this).next().is('span.select2')) {
            $(this).next().remove();
        }

        let select2;
        let options = {
            "language": {
                noResults: function () {
                    return "موردی یافت نشد";
                },
                inputTooShort: function (args) {
                    // args.minimum is the minimum required length
                    // args.input is the user-typed text
                    return "حداقل " + args.minimum + " کاراکتر بنویسید";
                },
                searching: function () {
                    return "در حال جستجو ...";
                },
                loadingMore: function () {
                    return 'در حال بارگزاری نتایج بیشتر...'
                },
                errorLoading: function () {
                    return "خطایی در بارگزاری رخ داد"
                },
                inputTooLong: function (e) {
                    var t = e.input.length - e.maximum, n = "لطفا " + t + " کاراکتر را حذف کن";
                    return t != 1 && (n += "s"), n
                },
                removeItem: function () {
                    return "حذف گزینه"
                },
                removeAllItems: function () {
                    return "حذف انتخاب شده(ها)"
                },
                maximumSelected: function (e) {
                    var t = "شما فقط میتوانید " + e.maximum + " گزینه انتخاب کنید";
                    return e.maximum != 1 && (t += "s"), t
                }
            },
            dir: "rtl",
            placeholder: ($(this).attr('data-placeholder') ?? ''),
            allowClear: true,
        }

        if ($(this).attr('data-modal')) {
            options.dropdownParent = $('#' + $(this).attr('data-modal'));
        }

        if (parseInt($(this).attr('data-min')) > 1) {
            options.minimumInputLength = parseInt($(this).attr('data-min'));
        }

        if ($(this).hasClass('select2-ajax')) {
            options.ajax = {};
            options.ajax.cache = true;
            options.ajax.url = '/select2/' + $(this).attr('data-url');
            options.ajax.delay = ($(this).attr('data-delay') ?? 250);
            options.ajax.dataType = 'json';

            if ($(this).parents('.wrapper-select-2').attr('data-params')) {
                let params = $(this).parents('.wrapper-select-2').attr('data-params');
                params = params.split('|');
                let objects = {};

                for (let i = 0; i < params.length; i++) {
                    let key_value = params[i].split("=>");
                    let key = key_value[0];
                    let value = key_value[1];
                    objects[key] = value;
                }

                options.ajax.data = function (term, page) {
                    return {
                        q: term, // search term
                        extra: objects, //Get your value from other elements using Query, for example.
                    };
                }
            }
        }

        if ($(this).attr('multiple') && $(this).attr('select-all') == 'true') {
            options.dropdownAdapter = $.fn.select2.amd.require('select2/selectAllAdapter');
        }

        select2 = $(this).select2(options);

        select2.unbind('select2:select');
        select2.on('select2:select', function (e) {
            let el = $(e.currentTarget);
            let data = e.params.data;

            let wire_id = get_livewire_id(el);
            let wrapper = el.closest('.with-method');
            if (wrapper.length) {
                let method = wrapper.data('method');
                let item = wrapper.data('item');

                Livewire.find(wire_id).$js[method](item,data);
            }

            let val = el.val();
            let model_name = el.attr('wire:model');
            if (!model_name) {
                model_name = el.attr('wire:model.live');
            }

            if (model_name) {
                set_livewire_vars(el, model_name, val, el.attr('data-live') === 'true');
            }
        });

        select2.unbind('select2:unselecting');
        select2.on('select2:unselecting', function (e) {
            let el = $(e.currentTarget);
            let model_name = el.attr('wire:model');
            if (!model_name) {
                model_name = el.attr('wire:model.live');
            }

            let value = '';
            if (el.attr('multiple')) {
                value = el.val()
                removeAllInstances(value, e.params.args.data.id)
            }

            if (model_name) {
                set_livewire_vars(el, model_name, value, el.attr('data-live') === 'true');
            }
        });

        select2.unbind('select2:clear');
        select2.on('select2:clear', function (e) {
            setTimeout(function () {
                select2.select2('close');
                jQuery('body.select2-container').remove();
            },10);
        });
    });
}
window.handle_select2 = handle_select2;

let all_dates = {};
let links = {};

function init_date_picker() {
    $(document).ready(function () {
        $('input.deletable').each(function () {
            let nextinput = $(this).next();
            nextinput.unbind('click');
            nextinput.click(function () {
                let input = $(this).prev('input');
                input.val('').attr('value', '').trigger('change');

                if (input.hasClass('date-links')) {
                    let name = input.attr('name');
                    let link_name = input.attr('data-link');
                    let form = input.parents('form');
                    links[name].touched = false;
                    if (links[link_name] && links[link_name].options) {
                        let cachedValue = links[link_name].getState().selected.unixDate;
                        links[link_name].options.maxDate = null;
                        links[link_name].options.minDate = null;
                        links[link_name].setDate(cachedValue);
                        if (!links[link_name].touched) {
                            form.find('[name="' + link_name + '"]').val('').attr('value', '').trigger('change');
                            form.find('[name="' + link_name + '"]').next().hide();
                            set_data_picker_var(form.find('[name="' + link_name + '"]'), true);
                        }
                    }
                }

                $(this).hide();
                set_data_picker_var($(this).prev('input'), true);
            });

            $(this).on('input', function () {
                if ($(this).prev('input').val() != '') {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            });
        });
    });

    function set_data_picker_var(obj, clear = false) {
        let el, name, value;
        if (!clear) {
            if (obj.model) {
                el = $(obj.model.input.elem);
                name = el.attr('name');
            } else {
                el = $(obj.input.elem);
                name = el.attr('name');
            }
        } else {
            el = obj;
            name = el.attr('name');
            value = '';
        }

        if (!clear) {
            value = fa2en(el.val());
            if (parseInt(value.split('/')[0]) + 600 > 2500) {
                el.attr('value', value);
            } else {
                el.attr('value', en2fa(value));
            }

            el.next().show();
        }

        set_livewire_vars(el, name, value);
    }

    $('.data-picker:not(.init-date-picker)').each(function () {
        $(this).addClass('init-date-picker');

        let options = {
            initialValue: false,
            calendarType: 'persian',
            format: 'YYYY/MM/DD',
            autoClose: true,
            viewMode: $(this).attr('data-type'),
            onSelect: function (unix) {
                set_data_picker_var(this);
            },
            calendar: {
                gregorian: {
                    locale: 'en',
                    showHint: false
                },
                persian: {
                    leapYearMode: 'astronomical',
                    showHint: false
                },
            },
            toolbox: {
                todayButton: {
                    onToday: function (date) {
                        set_data_picker_var(date);
                    }
                },
                calendarSwitch: {
                    onSwitch: function (date) {
                        set_data_picker_var(date);
                    }
                }
            },
            onSet: function () {
                set_data_picker_var(this);
            },
        };

        let that = $(this);
        if (that.attr('data-date')) {
            let date = that.attr('value');
            if (parseInt(fa2en(date.split('/')[0])) + 600 > 2500) {
                options.calendarType = 'gregorian';
            }
        }

        if ($(this).hasClass('date-links')) {
            options.onSelect = function (unix) {
                let name = $(this.model.input.elem).attr('data-link');
                let main_name = $(this.model.input.elem).attr('name');
                links[main_name].touched = true;
                if ($(this.model.input.elem).hasClass('max-date')) {
                    if (links[name] && links[name].options && links[name].options.maxDate != unix) {
                        let cachedValue = links[name].getState().selected.unixDate;
                        let date = $(this.model.input.elem).val();
                        if (parseInt(fa2en(date.split('/')[0])) + 600 > 2500) {
                            links[name].options = {
                                maxDate: unix,
                                calendarType: 'gregorian'
                            };
                        } else {
                            links[name].options = {
                                maxDate: unix,
                                calendarType: 'persian'
                            };
                        }

                        if (links[name].touched) {
                            links[name].setDate(cachedValue);
                        }
                    }
                } else {
                    if (links[name] && links[name].options && links[name].options.minDate != unix) {
                        let cachedValue = links[name].getState().selected.unixDate;
                        let date = $(this.model.input.elem).val();
                        if (parseInt(fa2en(date.split('/')[0])) + 600 > 2500) {
                            links[name].options = {
                                minDate: unix,
                                calendarType: 'gregorian'
                            };
                        } else {
                            links[name].options = {
                                minDate: unix,
                                calendarType: 'persian'
                            };
                        }

                        if (links[name].touched) {
                            links[name].setDate(cachedValue);
                        }
                    }
                }

                set_data_picker_var(this);
            }

            let that1 = jQuery(this);
            setTimeout(function () {
                let name = that1.attr('name');
                links[name] = that1.persianDatepicker(options);
                all_dates[that1.attr('id')] = links[name];
                if (that.attr('data-date')) {
                    links[name].setDate((new Date(that.attr('data-date'))).getTime())
                    links[name].touched = true;
                }
            },500)

        } else {
            let that1 = jQuery(this);
            setTimeout(function () {
                let pd = that1.persianDatepicker(options);
                all_dates[that1.attr('id')] = pd;

                if (that.attr('data-date')) {
                    pd.setDate((new Date(that.attr('data-date'))).getTime());
                    pd.touched = true;
                }
            },500)
        }
    });

    setTimeout(function () {
        $('.data-picker.init-date-picker').each(function () {
            let that = $(this);
            if ($(this).hasClass('date-links')) {
                if (that.attr('data-date')) {
                    let name = that.attr('data-link');
                    let main_name = that.attr('name');
                    if (links.hasOwnProperty('main_name')) {
                        links[main_name].touched = true;
                    }
                    let unix = new Date(that.attr('data-date')).getTime();
                    if (that.hasClass('max-date')) {
                        if (links[name] && links[name].options && links[name].options.maxDate != unix) {
                            let cachedValue = links[name].getState().selected.unixDate;
                            links[name].options = {maxDate: unix};
                            if (links[name].touched) {
                                links[name].setDate(cachedValue);
                            }
                        }
                    } else {
                        if (links[name] && links[name].options && links[name].options.minDate != unix) {
                            let cachedValue = links[name].getState().selected.unixDate;
                            links[name].options = {minDate: unix};
                            if (links[name].touched) {
                                links[name].setDate(cachedValue);
                            }
                        }
                    }
                }
            }
        });
    },600)
}

function call_after_reload_page() {
    setTimeout(function () {
        transform_money_input();
        handle_file_input();
        handle_select2();
        init_date_picker();
        setTimeout(function () {
            nav();

            //for (let i = 0; all_dates)
            for (const [key, value] of Object.entries(all_dates)) {
                let obj = $('#' + key);
                if (!obj.length) {
                    $('#' + value.model.view.id).remove();
                    delete all_dates[key]
                }
            }

            Inputmask().mask(document.querySelectorAll("input"));
        }, 200);
    }, 1);
}

document.addEventListener('livewire:initialized', initialize);
document.addEventListener('livewire:navigating', navigating);
document.addEventListener('livewire:navigated', navigated);

let stop_interval = false;
setInterval(function () {
    if (stop_interval) {
        return;
    }

    let path = window.location.pathname;
    jQuery('.nav-links li').removeClass('active');
    jQuery('.nav-links li a').removeClass('active');

    if (path == '/') {
        $('.sidebar-menu-dashboard').addClass('active');
        $('.sidebar-menu-dashboard a').addClass('active');
        return;
    }

    jQuery('.nav-links li a').each(function () {
        let that = $(this);
        if (path.includes(that.attr('href')) && that.attr('href') != '/') {
            if (that.parent().parent().parent().is('li')) {
                that.parent().parent().parent().addClass('active');
                that.addClass('active');
            } else {
                that.parent().addClass('active');
                that.addClass('active');
            }
        }
    });
},100)

function initialize() {
    // Header, Sidebar, Select2, Status Bar,... Events On Init Live-wire
    //setup_dashboard_third_party();

    // Define Live-wire Events
    define_live_wire_events();
}

function navigating() {
    stop_interval = true;

    let components = window.Livewire.all();
    for (let i = 0; i < components.length; i++) {
        window.Livewire.find(components[i].id).dispatch('upload:cancel', {name: undefined});
    }

    // Preventing Dashboard Jump and Flash When Come In to Dashboard from out of Panel
    if (location.pathname.search(/(login|register)/) >= 0) {
        jQuery('body').removeClass('open_sidebar close_sidebar');
        output_page = true;
    }

    // When Navigate To Another Page Keep Sidebar Scroll Position
    if ($('.sidebar').length) {
        scroll_top_sidebar = $('.sidebar')[0].scrollTop;
    }

    $('html,body').removeClass('swal2-shown swal2-toast-shown');

    // Keep body Class cause Dashboard jumping Before Navigate Start
    body_class = jQuery('body').attr('class');

    // Remove All Modal Defies Before Navigate Start
    $(".modal").data('bs.modal', null);
}

function navigated() {
    stop_interval = false;
    jQuery('body').on('click','.nav-links li a',function () {
        stop_interval = true;
    })

    // Header, Sidebar, Select2, Status Bar,... Events On Navigate Live-wire
    setup_dashboard_third_party();
}

function nav() {
    const navs = $(".js-nav");
    if (navs.length) {
        navs.each(function () {
            let nav = this;
            const navLinks = nav.querySelectorAll(".nav__link");
            const slideRect = nav.querySelector(".nav__slider-rect");

            $(slideRect).parent().attr('style', $(slideRect).parent().attr('style').split(';')[0]);
            $(slideRect).attr('style', 'transform:inherit;width: ' + (($(slideRect).parent().parent().parent()[0].scrollWidth / navLinks.length) - 6) + 'px');

            nav.addEventListener("click", (evt) => {
                if (!evt.target.classList.contains("nav__link")) {
                    return;
                }
                evt.preventDefault();

                navLinks.forEach((item) => {
                    item.classList.remove("nav__link_active");
                });

                if (!evt.target.classList.contains("nav__link_active")) {
                    evt.target.classList.add("nav__link_active");
                }

                var transform_size = $(evt.target).parent().width() * $(evt.target).parent().index();
                if ($(evt.target).parent().index() == 0) {
                    transform_size += 1;
                }
                $(slideRect).parent().attr('style', `transform: translateX(-${transform_size}px)`);
            });

            $('.nav__link_active').removeClass('initial_style');
            $(slideRect).removeClass('initial_width');
        });
    }
}


function setup_dashboard_third_party() {
    if (first_visit) {
        if (window.innerWidth > 767) {
            $('body').addClass('open_sidebar');
            $('.sidebar').removeClass('close');
        } else {
            $('body').addClass('close_sidebar');
            $('.sidebar').addClass('close');
        }
    } else {
        jQuery('body').attr('class', body_class);
        if ($('.sidebar').length) {
            $('.sidebar')[0].scrollTo(0, scroll_top_sidebar);
        }

        if (output_page) {
            output_page = false;
            if (window.innerWidth > 767) {
                $('body').addClass('open_sidebar');
                $('.sidebar').removeClass('close');
            } else {
                $('body').addClass('close_sidebar');
                $('.sidebar').addClass('close');
            }
        }

        $("html, body").animate({scrollTop: 0}, 300);
    }

    jQuery(document).ready(function ($) {
        setTimeout(function () {
            if (first_visit) {
                first_visit = false;
            } else {
                if (window.innerWidth < 768) {
                    $('body').addClass('close_sidebar');
                    $('body').removeClass('open_sidebar');
                    $('.sidebar').addClass('close');
                }
            }

            $('body').on('click', '.sidebar ul li .icon-link', function (e) {
                e.preventDefault();
                const arrowParent = e.target.closest('.icon-link').parentElement;
                let lis = document.querySelectorAll('.sidebar .nav-links > li');
                lis.forEach(function (item) {
                    if (item != arrowParent)
                        item.classList.remove('showMenu');
                });
                arrowParent.classList.toggle("showMenu");
            }).on('click', '#hamburger-btn', function () {
                if ($('body').hasClass('open_sidebar')) {
                    $('body').addClass('close_sidebar');
                    $('body').removeClass('open_sidebar');
                    $('.sidebar').addClass('close');
                } else {
                    $('body').addClass('open_sidebar');
                    $('body').removeClass('close_sidebar');
                    $('.sidebar').removeClass('close');
                }
            }).on('click', '.sidebar ul li a', function () {
                $('.sidebar ul li a').each(function () {
                    if ($(this).parent().parent().parent().is('li')) {
                        $(this).removeClass('active');
                        $(this).parent().parent().parent().removeClass('active');
                    } else {
                        $(this).removeClass('active');
                        $(this).parent().removeClass('active');
                    }
                });
                $(this).addClass('active');
                if ($(this).parent().parent().parent().is('li')) {
                    $(this).parent().parent().parent().addClass('active');
                } else {
                    $(this).parent().addClass('active');
                }
            });
        },200);

        $('body').on('click', 'a', function () {
            let a = $(this).attr('wire:navigate');
            if (typeof a !== 'undefined' && a !== false && $('.home-section').length) {
                $('.home-section').addClass('active-loading');
            }
        });

        window.addEventListener('popstate', function (event) {
            location.reload();
            return false;
            setTimeout(function () {
                $('.home-section').removeClass('active-loading');
            }, 100);
        }, false);

        let doit;
        let old_width = window.innerWidth;
        window.onresize = function () {
            clearTimeout(doit);
            doit = setTimeout(function () {
                if (Math.abs(window.innerWidth - old_width) > 20) {
                    if (window.innerWidth < 768) {
                        $('body').addClass('close_sidebar');
                        $('body').removeClass('open_sidebar');
                        $('.sidebar').addClass('close');
                    } else {
                        $('body').addClass('open_sidebar');
                        $('body').removeClass('close_sidebar');
                        $('.sidebar').removeClass('close');
                    }

                    old_width = window.innerWidth;
                }
            }, 100);
        };

        nav();

        call_after_reload_page();
    });
}

function define_live_wire_events() {
    Livewire.hook('request', ({succeed, fail}) => {
        succeed(({status, json}) => {
            call_after_reload_page();
        })
        fail(({status, preventDefault}) => {
            if (status === 419) {
                Swal.fire({
                    icon: 'error',
                    title: 'خطا',
                    text: '(صفحه را رفرش کنید) صفحه منقضی شده است لطفا صفحه را ببندید و مجددا باز کنید.',
                    confirmButtonText: 'باشه <i class="fa fa-thumbs-up"></i>',
                });
                preventDefault()
            }
        })
    })

    Livewire.on('start_timer', (data) => {
        clearInterval(timer_interval);

        setTimeout(function () {
            if ($('.timer').length) {
                $('[name="phone_code"]').trigger('focus');
                $('[name="phone_code"]').on('input', function () {
                    if ($(this).val().length >= 5) {
                        $('.login-btn').trigger('click');
                    }
                });

                $('.timer').attr('data-timer', data[0]);
                $('.timer').attr('data-time', data[1]);
                $('.timer').removeAttr('style');
                $('.timer').css('pointer-events', 'none');

                let timer = $('.timer').attr('data-timer');

                let now = data[2];

                // Find the distance between now and the count down date
                let distance = timer - now;

                // Time calculations for days, hours, minutes and seconds
                let minutes = Math.floor((distance % (60 * 60)) / (60));
                let seconds = Math.floor(distance % 60);

                // Display the result in the element with id="demo"
                $('.timer').html(zeroPad(minutes) + ":" + zeroPad(seconds));

                if (distance < 0) {
                    $('.timer').html("ارسال کد جدید؟").css({
                        'font-size': '14px',
                        'cursor': 'pointer',
                        'pointer-events': 'auto',
                    });

                    return;
                }

                // Update the count down every 1 second
                let i = 0;
                timer_interval = setInterval(function () {
                    // Get today's date and time
                    let now = data[2] + ++i;

                    // Find the distance between now and the count down date
                    let distance = timer - now;

                    // Time calculations for days, hours, minutes and seconds
                    let minutes = Math.floor((distance % (60 * 60)) / 60);
                    let seconds = Math.floor(distance % 60);

                    // Display the result in the element with id="demo"
                    $('.timer').html(zeroPad(minutes) + ":" + zeroPad(seconds));

                    // If the count down is finished, write some text
                    if (distance < 0) {
                        clearInterval(timer_interval);
                        $('.timer').html("ارسال کد جدید؟").css({
                            'font-size': '14px',
                            'cursor': 'pointer',
                            'pointer-events': 'auto',
                        });
                    }
                }, 1000);
            }
        }, 1);
    });

    Livewire.on('stop_timer', () => {
        setTimeout(function () {
            clearInterval(timer_interval);
        }, 1);
    });

    Livewire.on('load_modal_init', (data) => {
        setTimeout(function () {
            let target_class = '';
            if (data.target) {
                let attr = $(data.target).attr('wire:loading.class');
                $(data.target).addClass(attr);
                target_class = $(data.target).attr('class');
            }

            if (data.table_id && data.params?.id) {
                $('#' + data.table_id + ' .loading-table-wrapper').addClass('loading_on_table');
            }

            if (data.loading_page) {
                loading_section();
            }

            if (data.to_name) {
                Livewire.dispatchTo(data.to_name, 'load_modal', {
                    modal_id: data.modal_id,
                    params: data.params,
                    table_id: data.table_id,
                    target_class: target_class
                });
            } else {
                Livewire.dispatch('load_modal',
                    {
                        modal_id: data.modal_id,
                        params: data.params,
                        table_id: data.table_id,
                        target_class: target_class
                    }
                );
            }
        }, 1);
    });

    let modal_add_edit_load;
    Livewire.on('load_modal_end', (data) => {
        setTimeout(function () {
            if (!data.error_modal) {
                modal_add_edit_load = new bootstrap.Modal(data.id);

                $(document).on('show.bs.modal', data.id, function () {
                    setTimeout(function () {
                        nav();
                    }, 200);
                });

                $(data.id)[0].addEventListener('hide.bs.modal', function (event) {
                    window.Livewire.find(get_livewire_id(event.target))?.dispatch('upload:cancel', {name: undefined});
                    $(event.target).find('.z-index-top-on-uploading .fa-times')?.trigger('click');
                });

                $(data.id)[0].addEventListener('hidden.bs.modal', function (event) {
                    $('div.modal-backdrop').remove();
                });

                modal_add_edit_load.show();

                $(data.id + ' .modal-dialog').draggable({
                    handle: ".modal-header,.modal-footer"
                });
            }

            if (data.table_id) {
                $('#' + data.table_id).find('.loading-table-wrapper')?.removeClass('loading_on_table');
            }

            if (data.target_class) {
                let target_class = data.target_class.split(' ').join('.');
                let attr = $('.' + target_class).attr('wire:loading.class');
                $('.' + target_class).removeClass(attr);
            }
        }, 1);
    });

    Livewire.on('load_alert', (data) => {
        setTimeout(function () {
            if (modal_add_edit_load && (data.closeModal ?? true)) {
                modal_add_edit_load.hide();
            }
        }, 1);

        let title = {
            'success': 'موفقیت',
            'warn': 'هشدار',
            'info': 'توجه',
            'error': 'خطا',
        }

        let text = {
            'success': 'عملیات با موفقیت انجام شد',
            'warn': '',
            'info': '',
            'error': 'متاسفانه هنگام انجام عملیات خطایی رخ داد',
        }

        let icon;
        if (data.type == 'success') {
            icon = 'success';
        } else if (data.type == 'info') {
            icon = 'info';
        } else if (data.type == 'warn') {
            icon = 'warning';
        } else if (data.type == 'error') {
            icon = 'error';
        }

        if (data.toast) {
            let obj = {
                toast: true,
                position: 'bottom-start',
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                },
                title: (data.title ? data.title : text[data.type]),
                text: (data.text ? data.text : ''),
                showCloseButton: true,
                icon: icon
            };

            if (data.html) {
                obj.text = '';
                obj.html = data.html;
            }

            Swal.fire(obj);
        } else {
            let obj = {
                confirmButtonText: 'باشه <i class="fa fa-thumbs-up"></i>',
                cancelButtonText: 'نه <i class="fa fa-thumbs-down"></i>',
                title: (data.title ? data.title : title[data.type]),
                text: (data.text ? data.text : text[data.type]),
                showCancelButton: data.cancel ?? false,
                icon: icon
            };

            if (data.html) {
                obj.text = '';
                obj.html = data.html;
            }

            Swal.fire(obj);
        }
    });

    Livewire.on('input_modal', (data) => {
        Swal.fire({
            title: data.title,
            text: data.text,
            input: 'text',
            showCancelButton: true,
            confirmButtonText: 'نمایش',
            cancelButtonText: 'لغو',
        }).then((result) => {
            if (result.value) {
                data.value = result.value;
                loading_section();
                Livewire.dispatch(data.event_back, {data: data});
            }
        });
    });

    Livewire.on('loading_modal', (data) => {
        Swal.fire({
            title: 'در حال ساخت نماگشت',
            html: 'این عملیات ممکن از ۵ تا ۱۰ دقیقه زمانبر باشد',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        });

        Livewire.dispatch('create_namagasht', {data: data});
    });

    let tooltip_table = [];
    Livewire.on('load_table', function (data) {
        setTimeout(function () {
            (function ($) {
                if (data.search_id) {
                    $('#' + data.search_id + ' input,#' + data.search_id + ' button,#' + data.search_id + ' select').removeAttr('readonly').removeAttr('disabled');
                    let attr_class = $('#' + data.search_id + ' button').attr('wire:loading.class')
                    if (typeof attr_class !== 'undefined' && attr_class !== false) {
                        $('#' + data.search_id + ' button').removeClass(attr_class);
                    }
                }

                if ($('#' + data.table_id).length) {

                    if ($('#' + data.table_id + ' ul.pagination li').length > 9) {
                        $('#' + data.table_id + ' ul.pagination li.active')
                            .prev().addClass('show-mobile');
                        $('#' + data.table_id + ' ul.pagination li.active')
                            .next().addClass('show-mobile');

                        $('#' + data.table_id + ' ul.pagination').find('li.disabled').addClass('show-mobile');

                        $('#' + data.table_id + ' ul.pagination').find('li:first-child')
                            .next().addClass('show-mobile');

                        $('#' + data.table_id + ' ul.pagination').find('li:last-child')
                            .prev().addClass('show-mobile');

                        $('#' + data.table_id + ' ul.pagination')
                            .find('li:first-child, li:last-child, li.active')
                            .addClass('show-mobile');
                    } else {
                        $('#' + data.table_id + ' ul.pagination li').addClass('show-mobile')
                    }

                    if ($('#' + data.table_id + ' .fixed-header-table').length) {
                        $('#' + data.table_id + ' .fixed-header-table')[0].scrollTo(0, 0);
                    }

                    $('#' + data.table_id + " .select-all-table").on('change', function () {
                        let checks = $('#' + data.table_id + ' .select-input-table');
                        if (checks.length) {
                            if (this.checked) {
                                for (let i = 0; i < checks.length; i++) {
                                    if (!checks[i].checked) {
                                        checks[i].click();
                                    }
                                }
                            } else {
                                for (let i = 0; i < checks.length; i++) {
                                    if (checks[i].checked) {
                                        checks[i].click();
                                    }
                                }
                            }
                        }
                    });

                    let lastChecked = null;
                    let $checkboxes = $('#' + data.table_id + ' .select-input-table');
                    let disable_event_click = false;
                    if ($checkboxes.length) {
                        $checkboxes.click(function (e) {
                            if (disable_event_click) {
                                return;
                            }

                            if (!lastChecked) {
                                lastChecked = this;
                                return;
                            }

                            if (e.shiftKey) {
                                disable_event_click = true;
                                var start = $checkboxes.index(this);
                                var end = $checkboxes.index(lastChecked);

                                let is_reverse = false;
                                if (end > start) {
                                    is_reverse = true;
                                }

                                let selected_checkboxes = $checkboxes.slice(Math.min(start, end), Math.max(start, end) + 1);
                                for (let i = 0; i < selected_checkboxes.length; i++) {
                                    if (!is_reverse && i == selected_checkboxes.length - 1) {
                                        let temp_checked = lastChecked;
                                        setTimeout(function () {
                                            if (temp_checked.checked) {
                                                if (!selected_checkboxes[i].checked) {
                                                    selected_checkboxes[i].click();
                                                }
                                            } else {
                                                if (selected_checkboxes[i].checked) {
                                                    selected_checkboxes[i].click();
                                                }
                                            }
                                        }, 1);
                                        break;
                                    }

                                    if (is_reverse && i == 0) {
                                        let temp_checked = lastChecked;
                                        setTimeout(function () {
                                            if (temp_checked.checked) {
                                                if (!selected_checkboxes[0].checked) {
                                                    selected_checkboxes[0].click();
                                                }
                                            } else {
                                                if (selected_checkboxes[0].checked) {
                                                    selected_checkboxes[0].click();
                                                }
                                            }
                                        }, 1);
                                    }

                                    if (lastChecked.checked) {
                                        if (!selected_checkboxes[i].checked) {
                                            selected_checkboxes[i].click();
                                        }
                                    } else {
                                        if (selected_checkboxes[i].checked) {
                                            selected_checkboxes[i].click();
                                        }
                                    }
                                }
                                disable_event_click = false;
                            }

                            lastChecked = this;
                        });
                    }

                    let items_text = $('#' + data.table_id + ' table').attr('data-items');
                    if (items_text != '') {
                        let items = items_text.split(',');
                        if (items.length && $checkboxes.length) {
                            $checkboxes.each(function () {
                                let $check_value = $(this).val();
                                if (!items.includes($check_value)) {
                                    if (this.checked) {
                                        this.click();
                                    }
                                }
                            });
                        }
                    }

                    if (tooltip_table[data.table_id]) {
                        tooltip_table[data.table_id].dispose();
                        tooltip_table[data.table_id] = false;
                    }

                    setTimeout(function () {
                        let multi_sort = $('#' + data.table_id + " #table-multi-sort");
                        if (multi_sort.length) {
                            let text = '<div class="custom-header-tooltip">' + 'وضعیت فعلی: ' + (multi_sort.hasClass('btn-outline-success') ? 'فعال' : 'غیرفعال') + '</div>';
                            text = 'با استفاده از این قابلیت مرتب سازی بر اساس چند ستون فعال خواهد شد.<br> در شروع همه ی ستون ها را به حالت پیش فرض (فلش بالا و پایین) تغییر دهید سپس به ترتیب ستون ها را برای مرتب سازی انتخاب کنید.';
                            tooltip_table[data.table_id] = new bootstrap.Tooltip(multi_sort[0], {
                                title: text,
                                html: true,
                                customClass: 'tooltip-style-1 ' + data.table_id
                            });
                        }
                    }, 200);
                }
            })(jQuery);
        }, 1);
    });

    Livewire.on('refresh_table', function (data) {
        setTimeout(function () {
            if (data.table_id) {
                $('#' + data.table_id).find('.loading-table-wrapper').addClass('loading_on_table');
            }
            Livewire.dispatch('refresh_table_back', {table_id: data.table_id, search_id: data.search_id});
        }, 1);
    });

    Livewire.on('go_to_top', function (data) {
        let tag = "html, body";
        if (data.container) {
            tag = data.container;
        }

        if (data.all) {
            $(tag)[0].scrollTo({scrollTop: 0}, 0);
        } else {
            if (window.innerWidth < 768) {
                $(tag)[0].scrollTo({scrollTop: 0}, 0);
            }
        }
    });

    Livewire.on('send-form', function (data) {
        setTimeout(function () {
            let call_dispatch = false;
            if ($('#' + data.tableId).length) {
                let res = set_livewire_vars($('#' + data.tableId), 'search_data', $('#' + data.searchId).serialize());
                if (res) {
                    Livewire.dispatch('refresh_table', {table_id: data.tableId, search_id: data.searchId});

                    let attr_class = $('#' + data.searchId + ' button').attr('wire:loading.class')
                    if (typeof attr_class !== 'undefined' && attr_class !== false) {
                        $('#' + data.searchId + ' button').addClass(attr_class);
                    }
                    call_dispatch = true;
                }
            }

            if (!call_dispatch) {
                $('#' + data.searchId + ' input,#' + data.searchId + ' button,#' + data.searchId + ' select').removeAttr('readonly').removeAttr('disabled');
            }
        }, 1)
    });

    Livewire.on('table_all_select', function (data) {
        setTimeout(function () {
            $('#' + data.table_id + ' .select-all-table').trigger('click')
        }, 1);
    });

    Livewire.on('table_all_task', function (data) {
        let task = $('#' + data.table_id + ' #selected_table_task').val();

        if (!$('#' + data.table_id + ' .select-input-table:checked').val()) {
            Livewire.dispatch('load_alert', {
                'type': 'error',
                'text': 'لطفا حداقل یک گزینه را انتخاب کنید'
            });
            return;
        }

        let items_text = $('#' + data.table_id + ' table').attr('data-warning-table');
        if (items_text != '') {
            let items = items_text.split(',');
            if (items.includes(task)) {
                Livewire.dispatch('show_confirm_modal', {event: 'run_task', table_id: data.table_id})
                return;
            }
        }

        if (task == '') {
            Livewire.dispatch('load_alert', {
                'type': 'error',
                'text': 'لطفا یک عملیات را انتخاب کنید'
            });
        } else {
            $('#' + data.table_id + ' .loading-table-wrapper').addClass('loading_on_table')
            Livewire.dispatch('run_task');
        }
    });

    Livewire.on('show_confirm_modal', function (data) {
        Swal.fire({
            title: (data.title ? data.title : 'آیا مطئن هستید؟'),
            text: (data.text ? data.text : ''),
            icon: (data.icon ? data.icon : 'warning'),
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: (data.yesbtn ? data.yesbtn : 'بله، انجام بده!'),
            cancelButtonText: (data.nobtn ? data.nobtn : 'خیر')
        }).then((result) => {
            if (result.isConfirmed) {
                if ($('#' + data.table_id + ' .loading-table-wrapper').length) {
                    $('#' + data.table_id + ' .loading-table-wrapper').addClass('loading_on_table');
                }

                let target_class = '';
                if (data.target) {
                    let attr = $(data.target).attr('wire:loading.class');
                    $(data.target).addClass(attr);
                    target_class = $(data.target).attr('class');
                }

                /*if (data.target_class) {
                    let target_class = data.target_class.split(' ').join('.');
                    let attr = $('.' + target_class).attr('wire:loading.class');
                    $('.' + target_class).removeClass(attr);
                }*/

                if (data.loading_page) {
                    loading_section();
                }

                if (data.event) {
                    Livewire.dispatch(data.event, {data: data});
                } else if (data.event_back) {
                    Livewire.dispatch(data.event_back, {data: data});
                }
            }
        });
    });

    Livewire.on('reset_select2', function (data) {
        if (data.id) {
            $('#' + data.id + ' .select2').each(function () {
                $(this).val(null).trigger('change');
            });
        } else {
            $('.search-form .select2').each(function () {
                $(this).val(null).trigger('change');
            });
        }
    });

    Livewire.on('reset_date_picker', function (data) {
        if (data.id) {
            $('#' + data.id + ' .data-picker').each(function () {
                $(this).val(null).trigger('change');
                $(this).next().hide();
            });
        } else {
            $('.search-form .data-picker').each(function () {
                $(this).val(null).trigger('change');
                $(this).next().hide();
            });
        }
    });

    Livewire.on('set_switch_vars', function (data) {
        set_livewire_vars(data.event, data.name, data.value, data.live === 'true');
    });

    Livewire.on('refreshComponent', function (data) {
        if (data.name == 'sidebar') {
            loading_section();
            Livewire.getByName('shared.sidebar')[0].dispatch('refresh');
        }

        if (data.name == 'header') {
            loading_section();
            Livewire.getByName('shared.header')[0].dispatch('refresh');
        }

        if (data.name == 'service_item') {
            loading_section();
            Livewire.getByName('services.item')[0].dispatch('refresh');
        }

        if (data.name == 'ticket_item') {
            loading_section();
            $("html, body").animate({scrollTop: 0}, 300);
            Livewire.getByName('tickets.item')[0].dispatch('refresh');
        }
    });

    Livewire.on('setProfileImage', function (data) {
        if (data.path !== null && data.path !== false && data.path.length > 0) {
            $('.fixed-nav-on-top-content .dropdown img').attr('src', '/storage/' + data.path);
            $('.sidebar .text-center img.rounded-circle').attr('src', '/storage/' + data.path);
        }

        $('.fixed-nav-on-top-content .dropdown .username').html(data.name);
        $('.sidebar .username').html(data.name);
        $('.sidebar .type-of-user').html(data.user_type);
    });

    Livewire.on('removeLoading', function (data) {
        if ($('.home-section')) {
            Swal.close();
            setTimeout(function () {
                $('.home-section').removeClass('active-loading');
            }, 200);
        }
    });

    Livewire.on('redirect', function (data) {
        if (data.url && data.tab != true) {
            window.location.href = data.url;
        } else {
            window.open(data.url,"_blank");
        }
    });

    Livewire.on('copy_clipboard', function (data) {
        let text;
        if (data.class) {
            text = jQuery('.' + data.class).html().toString().trim();
        } else {
            text = data.text;
        }
        if (!navigator.clipboard) {
            let textArea = document.createElement("textarea");
            textArea.value = text;

            // Avoid scrolling to bottom
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.position = "fixed";

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                let successful = document.execCommand('copy');
                let msg = successful ? 'successful' : 'unsuccessful';
                if (msg == 'successful') {
                    Livewire.dispatch('load_alert', {
                        'type': 'success',
                        'title': 'با موفقیت در کلیپ‌بورد ذخیره شد',
                        'toast': true
                    });
                } else {
                    Livewire.dispatch('load_alert', {
                        'type': 'error',
                        'title': 'متاسفانه در کلیپ‌بورد ذخیره نشد',
                        'toast': true
                    });
                }
            } catch (err) {
                Livewire.dispatch('load_alert', {
                    'type': 'error',
                    'title': 'متاسفانه در کلیپ‌بورد ذخیره نشد',
                    'toast': true
                });
            }

            document.body.removeChild(textArea);
            return;
        }

        navigator.clipboard.writeText(text).then(function () {
            Livewire.dispatch('load_alert', {
                'type': 'success',
                'title': 'با موفقیت در کلیپ‌بورد ذخیره شد',
                'toast': true
            });
        }, function (err) {
            Livewire.dispatch('load_alert', {
                'type': 'error',
                'title': 'متاسفانه در کلیپ‌بورد ذخیره نشد',
                'toast': true
            });
        });
    });

    Livewire.on('download_text', function (data) {
        let text;
        if (data.class) {
            text = jQuery('.' + data.class).html().toString().trim();
        } else {
            text = data.text;
        }

        // Create element with <a> tag
        const link = document.createElement("a");

        // Create a blog object with the file content which you want to add to the file
        const file = new Blob([text], {type: 'text/plain'});

        // Add file content in the object URL
        link.href = URL.createObjectURL(file);

        // Add file name
        link.download = data.name ?? "download.txt";

        // Add click event to <a> tag to save file.
        link.click();
        URL.revokeObjectURL(link.href);
    });

    Livewire.on('set_order_messages_init', (data) => {
        setTimeout(function () {
            let target_class = '';
            if (data.target) {
                let attr = $(data.target).attr('wire:loading.class');
                $(data.target).addClass(attr);
                target_class = $(data.target).attr('class');
            }

            if (data.table_id && data.params?.id) {
                $('#' + data.table_id + ' .loading-table-wrapper').addClass('loading_on_table');
            }

            if (data.loading_page) {
                loading_section();
            }

            if (data.to_name) {
                Livewire.dispatchTo('', data.to_name, data.event, {
                    id: data.id,
                    params: data.params,
                    table_id: data.table_id,
                    target_class: target_class
                });
            } else {
                Livewire.dispatch(data.event,
                    {
                        id: data.id,
                        params: data.params,
                        table_id: data.table_id,
                        target_class: target_class
                    }
                );
            }
        }, 1);
    });

    Livewire.on('set_order_messages_end', (data) => {
        setTimeout(function () {
            if (!data.error_modal) {

                $(document).on('show.bs.modal', data.id, function () {
                    setTimeout(function () {
                        nav();
                    }, 200);
                });

                $(data.id)[0].addEventListener('hide.bs.modal', function (event) {
                    window.Livewire.find(get_livewire_id(event.target))?.dispatch('upload:cancel', {name: undefined});
                    $(event.target).find('.z-index-top-on-uploading .fa-times')?.trigger('click');
                });

                $(data.id)[0].addEventListener('hidden.bs.modal', function (event) {
                    $('div.modal-backdrop').remove();
                });

                modal_add_edit_load.show();

                $(data.id + ' .modal-dialog').draggable({
                    handle: ".modal-header,.modal-footer"
                });
            }

            if (data.table_id) {
                $('#' + data.table_id).find('.loading-table-wrapper')?.removeClass('loading_on_table');
            }

            if (data.target_class) {
                let target_class = data.target_class.split(' ').join('.');
                let attr = $('.' + target_class).attr('wire:loading.class');
                $('.' + target_class).removeClass(attr);
            }
        }, 1);
    });

    Livewire.on('go_to_end_textarea', function () {
        setTimeout(function () {
            var $textarea = $('textarea');
            $textarea.scrollTop($textarea[0].scrollHeight);
        }, 100);
    });

    Livewire.on('set_var_value', function (data) {
       setTimeout(function () {
           set_livewire_vars(jQuery(data.el),data.var_name,data.var_value,true);
       },1);
    });

    Livewire.on('tab_change',function (data) {
        setTimeout(function () {
            Livewire.dispatch(data.event,
                {
                    type: data.type,
                }
            );
        },1);
    });

    Livewire.on('log_highlight',function (data) {
        setTimeout(function () {
            jQuery(document).ready(function ($) {
                let prev = null;
                $('#'+data.id + ' table tbody tr').each(function (index,item) {
                    let that = $(item);
                    if (index != 0) {
                        that.find('td').each(function (inner_index, inner_item) {
                            if (inner_index != 0 && inner_index != 1 && inner_index != 2) {
                                if ((jQuery(inner_item).hasClass('change_attrs') || jQuery(inner_item).hasClass('change_files')) && jQuery(inner_item).html().trim() == 'بله') {
                                    jQuery(inner_item).css('background','#bbe9bb');
                                    return;
                                }

                                if ((jQuery(inner_item).hasClass('change_attrs') || jQuery(inner_item).hasClass('change_files')) && jQuery(inner_item).html().trim() == 'خیر') {
                                    return;
                                }

                                if (prev.find('td').eq(inner_index).html() != jQuery(inner_item).html()) {
                                    prev.find('td').eq(inner_index).css('background','#ffbfbf');
                                    jQuery(inner_item).css('background','#bbe9bb');
                                }
                            }
                        })
                    }
                    prev = that;
                });
            })
        },50);
    })
}

